<template>
	<div 
		class="color-item-wrapper d-inline-block"
		v-bind:class="classSelectColor"
	>
		<div 
			class="color-item d-inline-block"
			v-bind:data-code="item.code"
			v-bind:style="styleColorItem"
		>
			<div 
				class="color-item-name" 
				v-on:click="onClickSelect"
			>
				{{ item.name || '&nbsp;' }}
			</div>
			<v-btn fab flat
				class="color-item-btn"
				v-on:click="onClickEdit"
				:disabled="!hasAdmin"
				v-if="$store.getters.isEditable && isSingleSelect"
			>
				<v-icon>edit</v-icon>
			</v-btn>
		</div>
	</div>
</template>
<script>
import { PERMISSION } from '../data/Const';
import Color from '../data/Color';

export default {
	name: 'GBColorSelectItem',
	props: [
		"value",
		"master_colors",
		"item",
		"isSingleSelect",
	],
	methods: {
		onClickEdit: function(e) {
			e.stopPropagation();
			let code = e.target.closest('.color-item').dataset.code;
			this.$emit('color-edit', code);
		},
		onClickSelect: function(e) {
			e.stopPropagation();
			let code = e.target.closest('.color-item').dataset.code;
			this.$emit('color-select', code);
		},
	},
	computed: {
		classSelectColor: function() {
			let array = new Array();
			this.value.selected.forEach(c => {
				if (c.code === this.item.code) {
					array.push("active");
				}
			});
			return array;
		},
		hasAdmin: function() {
			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return false;
			
			return (access_token.pms & PERMISSION.TYPE.ADMIN) > 0;
		},
		styleColorItem: function() {
			let pr = 0;
			if (this.$store.getters.isEditable && this.isSingleSelect) 
				pr = 38;
				
			let color = this.createColor.asHex;
			
			return {
				'padding-right': pr + 'px',
				'border': 'solid 1px ' + color,
				'background-color': color,
			};
		},
		createColor: function() {
			let color = this.master_colors.find(c => c.code === this.item.code);
			return new Color(Object.assign(Object.assign({}, color)));
		},
	},
}
</script>
<style>
	.modal-window.color-select .color-item-wrapper {
		padding: 2px;
		margin: 2px;
	}
	.modal-window.color-select .color-item-wrapper.active {
		border-radius: 30px;
		background-color: #89c3eb;
	}
	.modal-window.color-select .color-item {
		position: relative;
		border-radius: 20px;
		font-size: 15px;
		height: 40px;
		margin: 5px;
		color: white;
	}
	.modal-window.color-select .color-item-name {
		display: flex;
		align-items: center;
		position: relative;
		top: -1px;
		left: -1px;
		border-radius: 20px 0px 0px 20px;
		height: 40px;
		padding: 0px 10px;
		cursor: pointer;
		user-select: none;
	}
	.modal-window.color-select .color-item-btn {
		position: absolute;
		border-radius: 0px 20px 20px 0px;
		top: -1px;
		right: -1px;
		height: 40px;
		width: 40px;
		margin: 0px;
		color: white;
	}
</style>
